
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoApprovalGrid extends Serenity.EntityGrid<PoApprovalRow, any> {
        protected getColumnsKey() { return PoApprovalColumns.columnsKey; }
        protected getDialogType() { return PoApprovalDialog; }
        protected getIdProperty() { return PoApprovalRow.idProperty; }
        protected getInsertPermission() { return PoApprovalRow.insertPermission; }
        protected getLocalTextPrefix() { return PoApprovalRow.localTextPrefix; }
        protected getService() { return PoApprovalService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}